// Mirrors FinkitUserPagesPermissions.RiskMonitoing.InstrumentProfitability.
export const InstrumentProfitabilityPermissions = {
  default: 'User.RiskMonitoring.InstrumentProfitability',
  consolidatedView: 'User.RiskMonitoring.InstrumentProfitability.ConsolidatedView',
} as const;
